import React from "react";

import { Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

export const TextCell: React.FC<{ value: string; color?: string; tooltip?: string }> = ({
  value,
  color = "#071f35",
  tooltip
}) => (
  <MaterialTooltip title={tooltip ?? value}>
    <Typography noWrap sx={{ display: "block", color }}>
      {value}
    </Typography>
  </MaterialTooltip>
);
